import React, { Component } from 'react';
import { CommonValidationMessages } from '../../utils/Messages';
import { isValidForm } from '../../utils/validation/CommonValidator';
import SwalServices from '../../services/swalServices/SwalServices';
import { Link } from 'react-router-dom';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { setAuthProps } from '../../utils/AuthenticationLibrary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            isLoading: false,
            showPassword: false,
            loginForm: {
                email: "",
                password: "",
            },
            rememberMe: false,
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "email"),
                    },
                    {
                        type: "email",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "valid email"),
                    },
                    {
                        type: "maxLength",
                        maxLength: 50,
                        message: "maximum length is 50"
                    },
                    {
                        type: "minLength",
                        minLength: 2,
                        message: "minimum length is 2",
                    },
                ],
                password: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                    },
                ],
            },
        };
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.loginForm,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.loginForm;
        details[name] = value;
        this.setState({ loginForm: details });
    };

    togglePasswordVisibility = () => {
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    userLogin = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = this.state.loginForm
            this.setState({ isLoading: true });
            this.adminServices.userLogin(request).then((response) => {
                if (response.success === 1) {
                    let rememberMe = this.state.rememberMe
                    let authDetails = response.userData.userDetails;
                    authDetails.token = response.token;
                    authDetails.rememberMe = rememberMe
                    if (this.state.rememberMe) {
                        localStorage.setItem('APToken', authDetails.token)
                    } else {
                        sessionStorage.setItem('APToken', authDetails.token);
                    }
                    setAuthProps(authDetails);
                    // this.swalServices.Success(response.msg)
                    window.location.href = authDetails.roleId === 3 ? "/visitor-reports" : "/dashboard";
                } else {
                    this.swalServices.Error(response.msg)
                }
                this.setState({ isLoading: false });
            });
        }
    }

    handleChangeCheckBox = (event) => {
        let value = event.target.checked
        this.setState({ rememberMe: value })
    }

    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            this.userLogin()
        }
    }

    render() {
        return (
            <div className='login'
            style={{ height: "calc(100dvh / 0.85)" }}>
                <div className='login-inner h-full flex'>
                    <div className='login-left h-full md:flex flex-col justify-center gap-[50px] px-[20px] md:px-[120px] md:w-full lg:w-[45%]'>
                        <div className='login-form'>
                            <div className='login-logo w-[180px] h-[83px] mb-[20px]'>
                                <img src='AHG-logo.svg' alt='Arbour Health Group' className='w-full h-full' />
                            </div>
                            <div className='login-title'>
                                <h1 className='text-[32px] font-medium mb-[10px] text-[#223645]'>Welcome back!</h1>
                                <p className='text-[16px] font-medium text-[#223645]'>
                                    Enter your credentials to access your account
                                </p>

                                <div className='login-form-inner mt-5'>
                                    <div className='form-group'>
                                        <div className='input-grp'>
                                            <label>Email address:</label>
                                            <input
                                                type='email'
                                                placeholder='Enter your email'
                                                id='email'
                                                name='email'
                                                className={`${this.state.validState?.error?.email ? "error" : ""}`}
                                                value={this.state.loginForm.email}
                                                onChange={(event) => this.handleChange(event, "email")}
                                                onKeyDown={(event) => this.handleKeyDown(event)}
                                            />
                                        </div>

                                        <div className='input-grp !mb-[10px] relative'>
                                            <label>Password:</label>
                                            <input
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                placeholder='Enter password'
                                                id='password'
                                                name='password'
                                                className={`pr-[40px] ${this.state.validState?.error?.password ? "error" : ""}`}
                                                value={this.state.loginForm.password}
                                                onChange={(event) => this.handleChange(event, "password")}
                                                onKeyDown={(event) => this.handleKeyDown(event)}
                                            />
                                            <span
                                                className='absolute right-3 top-[35px] cursor-pointer text-[#223645]'
                                                onClick={this.togglePasswordVisibility}
                                            >
                                                <i className={`fa ${this.state.showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className='extra-options flex justify-between items-center'>
                                    <label className='remember-box flex items-center gap-[5px] text-[#223645] text-[12px] font-medium'>
                                        <input
                                            type='checkbox'
                                            id='remember'
                                            name='remember'
                                            className='w-[15px] h-[15px] m-0'
                                            value={this.state.rememberMe}
                                            checked={this.state.rememberMe}
                                            onChange={(event) => this.handleChangeCheckBox(event)}
                                        />
                                        Remember me
                                    </label>

                                    <label className='forgot !text-[12px] !text-[#004AAD] !font-medium'>
                                        <Link to='/forgot-password'>Forgot password?</Link>
                                    </label>
                                </div>

                                {this.state.isLoading ? (
                                    <button
                                        onClick={() => this.userLogin()}
                                        className='prm-btn btn w-full mt-[30px] flex items-center justify-center gap-[5px]'
                                    >
                                        <FontAwesomeIcon icon={faCircleNotch} spin />
                                        Verifying
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => this.userLogin()}
                                        className='prm-btn btn w-full mt-[30px]'
                                    >
                                        Login
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className='copyright'>
                            <p className='text-[10px] text-center font-medium text-[#64748B]'>
                                Copyright 2025. Arbour Healthcare Group All Rights Reserved.
                            </p>
                        </div>
                    </div>

                    <div className="hidden md:hidden lg:block login-right p-[30px] md:w-[55%] h-full">
                        <div className='login-right-inner h-fit rounded-t-full flex justify-center' style={{ height: "calc(100vh - 60px)" }}>
                            <img src='AHG-logo.svg' alt='Arbour tree' className='w-[100%] h-auto mx-auto' />
                        </div>
                    </div>
                    {/* <div className='items-center justify-center w-full h-[100VH] md:hidden  flex lg:block '>
                        <p>
                            hello
                        </p>
                    </div> */}

                </div>
            </div>

        );
    }
}
